<template>
  <PortalAuthLayout v-if="usePortalBrandingLayout" />
  <AuthLayout v-else />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import PortalAuthLayout from '@/layouts/PortalAuthLayout.vue'
import { isClientPortalHost } from '@/utils/clientPortalHost'
import { isDetachedPortalApp } from '@/utils/portalMode'
import { shouldFetchPortalConfig } from '@/utils/portalHost'

/** Pick white-label portal chrome at runtime (works even if monolith build is served on a client domain). */
const usePortalBrandingLayout = computed(() => {
  if (isDetachedPortalApp()) return true
  if (typeof window === 'undefined') return false
  const host = window.location.hostname
  return isClientPortalHost(host) || shouldFetchPortalConfig(host)
})
</script>
